import JobDetails from './JobDetails'
export default JobDetails
